import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { Team } from '@/modules/team/models/Team';

export class WorkflowTeamRule extends BaseEntityModel {
  id?: number;

  workflowId?: number;

  teamId?: number;

  team?: Relationship<Team>;

  constructor(model: Partial<WorkflowTeamRule> = {}) {
    super(model);

    this.id = model.id;
    this.workflowId = model.workflowId;
    this.teamId = model.teamId;
    this.team = Team.mapModelOrNull(model.team) || undefined;
  }
}
